import { render } from "./HeaderBasket.vue?vue&type=template&id=7518e8e4&scoped=true"
import script from "./HeaderBasket.vue?vue&type=script&lang=js"
export * from "./HeaderBasket.vue?vue&type=script&lang=js"

import "./HeaderBasket.vue?vue&type=style&index=0&id=7518e8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7518e8e4"]])

export default __exports__